import { render, staticRenderFns } from "./Insurance.vue?vue&type=template&id=5cef827d&scoped=true"
import script from "./Insurance.vue?vue&type=script&lang=js"
export * from "./Insurance.vue?vue&type=script&lang=js"
import style0 from "./Insurance.vue?vue&type=style&index=0&id=5cef827d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cef827d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cef827d')) {
      api.createRecord('5cef827d', component.options)
    } else {
      api.reload('5cef827d', component.options)
    }
    module.hot.accept("./Insurance.vue?vue&type=template&id=5cef827d&scoped=true", function () {
      api.rerender('5cef827d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/Insurance.vue"
export default component.exports